/**
 * 加解密配置管理
 * 可以从环境变量或localStorage中读取配置
 */

/**
 * 默认配置值
 */
const defaultConfig = {
  // 是否启用加解密（默认：false，但可以从localStorage动态读取）
  enabled: false,

  // 加密类型：AES、RSA 或 HYBRID（混合加密：RSA加密AES密钥 + AES加密数据）
  // 默认：HYBRID（混合加密）
  cryptoType: 'HYBRID',

  // 加密密钥（用于请求加密，AES模式使用）
  encryptKey: '2nHtbGAYxq3wgZZdcFtye5LKYSuAmWVz',

  // 解密密钥（用于响应解密）
  // AES模式：AES密钥字符串
  // 混合加密模式：RSA私钥（Base64编码，不包含BEGIN/END标记）
  decryptKey: 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCcO9vBc3lY0c4ns0+rvZ97EwYppzqSln7n+q4rNIiNA5UNiGNzA1OmPAxmEBb8rNa5zUYrC/SplNvzGyeYxGd69c1fgq4tP8CHBc3qgWZfFMJO9PB/5r5PCmrkv/zR/+9pT87oU2TL1Gqw+2ZLW/4CW4JFdT7XJJwF5ULZCI1sGIgM85EO9HfUs4A3go+WgEKV9VHZ5ma6mDtQtC9cTgDwA9dxYAlSSD/th1XUTHyr72xKuf+lt6yv4KF+iVAGnwvT+b/yToCobGntx9/xYB0TRKsRTvyemTGfCQvmDT2OJr32UXLDH+9yScnx+hWNyasG8Z9rJ58CMZ3HkwTV1BH1AgMBAAECggEAGyewT5SBj/WPjoj1HRWtZZft50mAvb/YuPtyUGImJdRskNiW6IO4g1lGkmrThAGKpOrP+mVulhcgj8W1gTEKB243zxUIrya4kP9qRgtNvtL93vll3+U8SMK3x6CzEdEZTMWpYeo0x9TY4oAfzJNluAUtxGLXlE9xqvipQM3ivtnTAN/FLBZzW/RqzLOxTkTWYgViCtpEs88u728pdbUX7b+EssFwVpch28zzbyBnPGWfVM68E/srv8rcXb+uP5VazFgWdN5bMJLmJCaKHNcNTlomuaK1LaWqG5eOGt/Q0Usgi1hRRULY0aHdBDUe+kTem9OfPZE8bZWq6vtpjRQDgQKBgQDWz7fiHe8Lslrc3CsCnZxBpAYxR0Oa3aQs/CH0fGn68SJVyWPqE//q6A51mMCZJiA4FcWrZGY33YWhKkc68vSmFcdro09PnzbvMeSoy7we8vMeWvut65x2ILAIVPtuyfZY/dPblrk5UROUtesjwI8VEKK7OZaN+sjX9GHIZXqO1QKBgQC6MMmmXBKggv0syCwEwkagfYZOwFc/yBmjVz5QnBjYYJCXKFSCfL/Wj/XkkX1/UO54oVJuCgEeRo3g618YnyuAVhmikEmlbgZV66yZFGZA7piWfj5Ma9xl4n+4hEig30s1m4qt0Gm4nRKMvw44oW5BiNrstPu0h8zns3OoKupGoQKBgQCMUZ+yiw8tutHz17YYvU/m6PhKlFyq+wFViVW82NB55a4iD62+qFXR4sgfNSsKX4dIW6CF9s12zLOPtYhWD4KUQ0HDJCiYwE4oLZVKVduK8/Sv7Yrd7zyDRZL3vluH4VGUjCoqFOjlcfqyd6sj7ZMJlZZXaqTYFevAdZiySOeoCQKBgHdmD/ph8wQB3C9aknfeygHjXTylNY5OWLqZmPmCkKA5lJ+Kml8vdqo2mX4hGrSJhtPOyBiOy9bJcfR5m/sjH3dmP3wzQTcYDnIM9xsXrNcY6rsfa/3/8U9Y54TBN/4KE6XmABGkpBdiiuG9J3aDdzwJcjL3gK5to6Y2OwXtt1zhAoGAVFfpu/KIlz80wpAdtvoABtzAV0mUTkIzUddgHfZXKlaqmM5XdpplU+Zuyq2iDqvNkbIY8ADnyJDwDvFRC+VI5YjYKlXFM+XqpetEd4scbPWpGSYwdbMOzkZuNBP7iq1IReoRJ2whE7m5TSOVWgjfe8vE2jSkHucDnQrkxASZQko=',

  // APP服务的RSA公钥（用于混合加密）
  appRsaPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnDvbwXN5WNHOJ7NPq72fexMGKac6kpZ+5/quKzSIjQOVDYhjcwNTpjwMZhAW/KzWuc1GKwv0qZTb8xsnmMRnevXNX4KuLT/AhwXN6oFmXxTCTvTwf+a+Twpq5L/80f/vaU/O6FNky9RqsPtmS1v+AluCRXU+1yScBeVC2QiNbBiIDPORDvR31LOAN4KPloBClfVR2eZmupg7ULQvXE4A8APXcWAJUkg/7YdV1Ex8q+9sSrn/pbesr+ChfolQBp8L0/m/8k6AqGxp7cff8WAdE0SrEU78npkxnwkL5g09jia99lFywx/vcknJ8foVjcmrBvGfayefAjGdx5ME1dQR9QIDAQAB',

  // Admin服务的RSA公钥（用于混合加密）
  adminRsaPublicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnDvbwXN5WNHOJ7NPq72fexMGKac6kpZ+5/quKzSIjQOVDYhjcwNTpjwMZhAW/KzWuc1GKwv0qZTb8xsnmMRnevXNX4KuLT/AhwXN6oFmXxTCTvTwf+a+Twpq5L/80f/vaU/O6FNky9RqsPtmS1v+AluCRXU+1yScBeVC2QiNbBiIDPORDvR31LOAN4KPloBClfVR2eZmupg7ULQvXE4A8APXcWAJUkg/7YdV1Ex8q+9sSrn/pbesr+ChfolQBp8L0/m/8k6AqGxp7cff8WAdE0SrEU78npkxnwkL5g09jia99lFywx/vcknJ8foVjcmrBvGfayefAjGdx5ME1dQR9QIDAQAB',

  // 排除路径（这些路径不进行加解密，多个路径用逗号分隔）
  excludes: '/swagger-ui'
}

/**
 * 加解密配置（使用getter确保每次读取最新值）
 */
const encryptConfig = {
  get enabled() {
    // 勿用 Object.assign 直接写 encryptConfig.enabled，否则会覆盖本 getter
    const envValue = String(process.env.VUE_APP_ENCRYPT_ENABLED || '').trim().toLowerCase()
    if (envValue === 'true') return true
    if (envValue === 'false') return false

    const storageValue = localStorage.getItem('encrypt.enabled')
    if (storageValue === 'true') return true
    if (storageValue === 'false') return false

    return defaultConfig.enabled
  },

  get cryptoType() {
    return process.env.VUE_APP_ENCRYPT_TYPE || localStorage.getItem('encrypt.cryptoType') || defaultConfig.cryptoType
  },

  get encryptKey() {
    return process.env.VUE_APP_ENCRYPT_KEY || localStorage.getItem('encrypt.encryptKey') || defaultConfig.encryptKey
  },

  get decryptKey() {
    return process.env.VUE_APP_ENCRYPT_DECRYPT_KEY || localStorage.getItem('encrypt.decryptKey') || defaultConfig.decryptKey
  },

  get appRsaPublicKey() {
    return process.env.VUE_APP_ENCRYPT_APP_RSA_PUBLIC_KEY || localStorage.getItem('encrypt.appRsaPublicKey') || defaultConfig.appRsaPublicKey
  },

  get adminRsaPublicKey() {
    return process.env.VUE_APP_ENCRYPT_ADMIN_RSA_PUBLIC_KEY || localStorage.getItem('encrypt.adminRsaPublicKey') || defaultConfig.adminRsaPublicKey
  },

  get excludes() {
    return process.env.VUE_APP_ENCRYPT_EXCLUDES || localStorage.getItem('encrypt.excludes') || defaultConfig.excludes
  }
}

/**
 * 检查路径是否需要加密
 * @param {String} url - 请求URL
 * @returns {Boolean} 是否需要加密
 */
export function shouldEncrypt(url) {
  // 每次都重新读取配置，确保获取最新值
  const enabled = encryptConfig.enabled
  if (!enabled) {
    return false
  }

  // 检查排除路径
  const excludes = encryptConfig.excludes
  if (excludes) {
    const excludeList = excludes.split(',')
    for (const exclude of excludeList) {
      if (url.includes(exclude.trim())) {
        return false
      }
    }
  }

  return true
}

/**
 * 根据URL获取对应的RSA公钥
 * @param {String} url - 请求URL
 * @returns {String} RSA公钥
 */
export function getRsaPublicKeyByUrl(url) {
  if (!url) {
    return encryptConfig.adminRsaPublicKey || encryptConfig.appRsaPublicKey
  }

  // APP服务路径
  if (url.includes('/app-api') || url.startsWith('/app-api')) {
    return encryptConfig.appRsaPublicKey
  }

  // Admin服务路径（默认）
  return encryptConfig.adminRsaPublicKey
}

/**
 * 获取加密配置（每次都重新读取最新值）
 */
export function getEncryptConfig() {
  return {
    enabled: encryptConfig.enabled,
    cryptoType: encryptConfig.cryptoType,
    encryptKey: encryptConfig.encryptKey,
    decryptKey: encryptConfig.decryptKey,
    appRsaPublicKey: encryptConfig.appRsaPublicKey,
    adminRsaPublicKey: encryptConfig.adminRsaPublicKey,
    excludes: encryptConfig.excludes
  }
}

/**
 * 清除 Object.assign 遗留的自有属性，避免覆盖 getter
 */
function clearEncryptConfigOverrides () {
  const keys = ['enabled', 'cryptoType', 'encryptKey', 'decryptKey', 'appRsaPublicKey', 'adminRsaPublicKey', 'excludes']
  keys.forEach(key => {
    if (Object.prototype.hasOwnProperty.call(encryptConfig, key)) {
      delete encryptConfig[key]
    }
  })
}

/**
 * 更新加密配置
 */
export function setEncryptConfig(config) {
  clearEncryptConfigOverrides()

  // 保存到localStorage
  if (config.enabled !== undefined) {
    localStorage.setItem('encrypt.enabled', String(config.enabled))
  }
  if (config.cryptoType) {
    localStorage.setItem('encrypt.cryptoType', config.cryptoType)
  }
  if (config.encryptKey) {
    localStorage.setItem('encrypt.encryptKey', config.encryptKey)
  }
  if (config.decryptKey) {
    localStorage.setItem('encrypt.decryptKey', config.decryptKey)
  }
  if (config.appRsaPublicKey) {
    localStorage.setItem('encrypt.appRsaPublicKey', config.appRsaPublicKey)
  }
  if (config.adminRsaPublicKey) {
    localStorage.setItem('encrypt.adminRsaPublicKey', config.adminRsaPublicKey)
  }
  if (config.excludes) {
    localStorage.setItem('encrypt.excludes', config.excludes)
  }
}

/**
 * 启用加密功能（便捷方法）
 * 使用示例：import { enableEncrypt } from '@/utils/encrypt-config'; enableEncrypt();
 */
export function enableEncrypt() {
  setEncryptConfig({ enabled: true })
}

/**
 * 禁用加密功能（便捷方法）
 */
export function disableEncrypt() {
  setEncryptConfig({ enabled: false })
}

export default encryptConfig
